import React from 'react';
import styles from './preloader.module.css';
import { ReactComponent as Rocket } from './rocket.svg';
import { ReactComponent as Waves } from './waves.svg';
import { useStores } from '../../../hooks/useStore';
import { observer } from 'mobx-react';

export const Preloader: React.FC = observer(() => {

	const { notificationsStore }  = useStores();

	return (
		<>
			{notificationsStore.preloader &&
			<div className={styles.fon}>
				<div className={styles.preloaderWrap}>
					<div className={styles.preloader}>
						<div className={styles.rocket}>
							<Rocket className={styles.icon}/>
						</div>
						<Waves className={styles.waves}/>
					</div>
				</div>
			</div>
			}
		</>
	);
});

export default Preloader;